// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.04.036C8.656.238 6.437 1.104 4.596 2.553c-4.498 3.54-5.886 9.744-3.32 14.835A11.988 11.988 0 0 0 12 24c1.89 0 3.703-.43 5.388-1.277a12.051 12.051 0 0 0 5.057-4.807c.86-1.511 1.422-3.367 1.522-5.023.009-.149.025-.276.036-.283.012-.007.02-.296.02-.641 0-.346-.009-.615-.02-.597-.012.018-.026-.086-.036-.252-.095-1.651-.66-3.52-1.522-5.036A12.033 12.033 0 0 0 13.62.107a13.385 13.385 0 0 0-2.58-.071m.216 1.491c-1.459.13-2.602.436-3.828 1.027a10.544 10.544 0 0 0-4.874 4.874 10.488 10.488 0 0 0-.987 3.396c-.06.496-.06 1.856 0 2.352.246 2.01.995 3.82 2.209 5.341a10.502 10.502 0 0 0 6.424 3.824c.642.113.933.134 1.8.134s1.158-.021 1.8-.134a10.51 10.51 0 0 0 5.888-3.2c1.549-1.68 2.46-3.662 2.745-5.965.06-.497.06-1.855 0-2.352-.25-2.014-1.001-3.834-2.207-5.34-1.768-2.208-4.197-3.56-7.026-3.914-.287-.036-1.679-.067-1.944-.043M7.23 11.296a.886.886 0 0 0-.415.398.67.67 0 0 0-.056.306c0 .239.067.392.24.55.232.212-.238.194 5.001.194 5.24 0 4.77.018 5.002-.194a.665.665 0 0 0 .24-.55.665.665 0 0 0-.24-.55c-.233-.212.239-.194-5.012-.192-4.09.002-4.67.006-4.76.038M.01 12c0 .35.004.493.008.318s.004-.461 0-.636S.01 11.65.01 12"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const RatingNeutralIcon = Icon;
export default RatingNeutralIcon;
